<adapt-dialog [maxWidth]="600">
    <h3 adapt-dialog-title>Move objective</h3>
    @if (!isDialogClosing && isInitialised) {
        <div adapt-dialog-content>
            <div class="alert"
                 [ngClass]="{ 'alert-info': canMove, 'alert-danger': !canMove }">
                @if (originTeam) {
                    @if (canMove) {
                        Team objectives can be moved
                        @if (canMoveBetweenTeams) {
                            <span>between teams{{ canMoveToOrg ? "" : "." }}</span>
                        }
                        @if (canMoveToOrg) {
                            <span>{{ canMoveBetweenTeams ? ", or moved" : "" }} to become an organisational objective.</span>
                        }
                    }
                    <!-- Additional info on why you cannot move in certain cases -->
                    @if (!canMoveBetweenTeams) {
                        <p>Team objectives cannot be moved between teams if they are supported by other child objectives or currently
                            supporting another team objective.</p>
                    }
                    @if (!canMoveToOrg) {
                        <p>Team objectives cannot be moved to become an organisational objective if they are currently supporting another
                            objective.</p>
                    }
                }
                @if (!originTeam) {
                    @if (canMoveToTeam) {
                        <p>Organisational objectives can be only moved to another team.</p>
                    }
                    @if (!canMoveToTeam) {
                        <p>Organisational objectives with supporting child objectives cannot be moved.</p>
                    }
                }
            </div>
            @if (canMove) {
                @if (canMoveToTeam || canMoveBetweenTeams) {
                    <div class="form-group">
                        <label class="mb-2"
                               for="objectiveTeam">Destination Team</label>
                        <adapt-select-team id="objectiveTeam"
                                           [(team)]="objective.team"
                                           (teamChange)="onTeamChange()"
                                           [filter]="hasObjectivesEnabled"
                                           [required]="true"
                                           data-test="select-objective-team"> </adapt-select-team>
                    </div>
                }
                @if (originTeam && canMoveToOrg) {
                    <dx-check-box class="mb-3"
                                  (onValueChanged)="onMakeOrgObjectiveChange()"
                                  [(value)]="makeOrganisationObjective"
                                  data-test="make-objective-global"
                                  text="Make this an organisation objective"> </dx-check-box>
                }
                <ul class="mb-0 pt-3 border-top">
                    @if (objective.team) {
                        <li>
                            This will move the objective to the
                            <strong>{{ objective.team.name }}</strong> team.
                        </li>
                    }
                    @if (!objective.team && originTeam && makeOrganisationObjective) {
                        <li>
                            This will move the objective to the
                            <strong>Organisation</strong> from the <strong>{{ originTeam.name }}</strong> team.
                        </li>
                    }
                    <li>Once the objective is moved, you will be navigated to the new objective location.</li>
                </ul>
            }
        </div>
    }
    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveText="Move objective"
                                   [saveIsDisabled]="saveIsDisabled()"
                                   (saveClick)="save()"
                                   (cancelClick)="cancel()"> </adapt-standard-dialog-buttons>
</adapt-dialog>
